<template>
  <header class="app-header" :class="{ 'is-scrolled': isScrolled }">
    <div class="container">
      <a href="https://www.astoc.co.kr" class="logo">
        <img src="@/assets/images/astoc.png" alt="ASTOC Logo" />
      </a>
      <nav>
        <a href="#product" class="nav-link">제품소개</a>
        <a href="#cases" class="nav-link">시공사례</a>
        <a href="#cta" class="btn btn-primary">상담 신청</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  data() {
    return {
      isScrolled: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    }
  }
};
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--header-height);
  padding: 0 20px;
  z-index: 1000;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.app-header.is-scrolled {
  background-color: var(--bg-white);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.app-header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  height: 100%;
}
.logo {
  height: 100%;
}
.logo img {
  height: 100%;
  width: auto;
}
.app-header nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}
.app-header nav .nav-link {
  color: var(--text-dark);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}
.app-header.is-scrolled nav .nav-link {
  color: var(--text-dark);
}
.app-header nav .nav-link:hover,
.app-header.is-scrolled nav .nav-link:hover {
  color: var(--primary-red);
}
.app-header .btn {
  padding: 0.5rem 1.5rem;
  font-weight: 700;
}
</style>
